// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { theme } from './theme';
import { CSSObject, SimpleInterpolation, css } from 'styled-components';

type Breakpoints = {
  xs: string;
  sm: string;
  md: string;
  mdlg: string;
  lg: string;
};

export const breakpoints: Breakpoints = {
  xs: theme.breakpoints.xs,
  sm: theme.breakpoints.sm,
  md: theme.breakpoints.md,
  mdlg: theme.breakpoints.mdlg,
  lg: theme.breakpoints.lg,
};

export const up = Object.keys(breakpoints).reduce(
  (
    accumulator: Record<
      keyof Breakpoints,
      (...args: (CSSObject | TemplateStringsArray)[]) => SimpleInterpolation
    >,
    label
  ) => {
    accumulator[label as keyof Breakpoints] = (
      ...args: (CSSObject | TemplateStringsArray)[]
    ) => css`
      @media (min-width: ${breakpoints[label as keyof Breakpoints]}) {
        ${css(args as any)};
      }
    `;

    return accumulator;
  },
  {} as Record<
    keyof Breakpoints,
    (...args: (CSSObject | TemplateStringsArray)[]) => SimpleInterpolation
  >
);

export const down = Object.keys(breakpoints).reduce(
  (
    accumulator: Record<
      keyof Breakpoints,
      (...args: (CSSObject | TemplateStringsArray)[]) => SimpleInterpolation
    >,
    label
  ) => {
    accumulator[label as keyof Breakpoints] = (
      ...args: (CSSObject | TemplateStringsArray)[]
    ) => css`
      @media (max-width: ${breakpoints[label as keyof Breakpoints]}) {
        ${css(args as any)};
      }
    `;

    return accumulator;
  },
  {} as Record<
    keyof Breakpoints,
    (...args: (CSSObject | TemplateStringsArray)[]) => SimpleInterpolation
  >
);
